import styled from 'styled-components';

import { Box } from 'components/Box';
import { breakpoints } from 'theme';
import { getImageSrc } from 'utils/getImageSrc';
import { hiDPI } from 'utils/style';

export const CmsSignUpBlockContainer = styled(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ imageHandle, ...props }: any) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box {...props} />
  ),
)`
  background-size: cover;
  background-position: center;
  ${({ imageHandle, mimetype }) =>
    imageHandle &&
    `
    background-image: url('${getImageSrc({
      handle: imageHandle,
      mimetype,
      width: 800,
    })}');
    ${hiDPI()}: {
      background-image: url('${getImageSrc({
        handle: imageHandle,
        mimetype,
        width: 1600,
      })}');
    }
    @media (min-width: ${breakpoints[3]}) {
      background-image: url('${getImageSrc({
        handle: imageHandle,
        mimetype,
        width: 1280,
      })}');
      ${hiDPI()}: {
        background-image: url('${getImageSrc({
          handle: imageHandle,
          mimetype,
          width: 2560,
        })}');
      }
    }
  `}
`;
